import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { KibSelect } from '@chewy/kib-fields-new-react'
import { FormControl, InputLabel } from '@mui/material'
import { pluck } from 'ramda'
import {
  type Constant,
  type Field,
  LanguageUtils,
  PuiSelect,
} from '@pbt/pbt-ui-components'

import { getImagingVendorModality } from '~/store/duck/imagingOrders'
import { useGetIdexxImagingId } from '~/store/hooks/constants'
import { getImagingModalities } from '~/store/reducers/constants'

import '@chewy/kib-fields-new-styles/dist/styles/kib-select.css'

export interface ModalitySelectProps {
  field: Field
  isChirp?: boolean
  vendorId?: string
}

const ModalitySelect = ({
  field,
  vendorId: vendorIdProp,
  isChirp = false,
}: ModalitySelectProps) => {
  const ImagingModalities: Constant[] = useSelector(getImagingModalities)
  const idexxVendorId = useGetIdexxImagingId()
  const vendorId = vendorIdProp || idexxVendorId
  const businessScopeModalities =
    useSelector(getImagingVendorModality(vendorId)) || []
  const businessScopeModalityIds = pluck('modalityId', businessScopeModalities)
  const { t } = useTranslation('Common')

  const modalityOptions = ImagingModalities.filter(({ id }) =>
    businessScopeModalityIds.includes(id),
  )

  if (isChirp) {
    return (
      <KibSelect
        label={t('Common:MODALITY')}
        value={field.value}
        onChange={(e) => field.setValue(e.target.value)}
      >
        {modalityOptions.map((modality) => (
          <option key={modality.id} value={modality.id}>
            {LanguageUtils.getTranslatedFieldName(modality)}
          </option>
        ))}
      </KibSelect>
    )
  }

  return (
    <FormControl fullWidth margin="none">
      <InputLabel>{t('Common:MODALITY')}</InputLabel>
      <PuiSelect field={field} items={modalityOptions} />
    </FormControl>
  )
}

export default ModalitySelect
